import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { LoginService } from 'src/app/services/login.service';
import {BankingDayService} from "@app/services/banking-day.service";
import {NotificationService} from "@app/services/notification.service";
import {GlobalErrorHandlerService} from "@app/services/global-error-handler.service";
import {CurrencyService} from "@app/services/currency.service";
import { TranslateService } from '@ngx-translate/core';
import { Currency } from '@app/models/currency';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

  user: User = new User();
  errorMessage: string | boolean = '';

  eyeOpened = false;

  constructor(
    private loginService: LoginService,
    private authorizationService: AuthorizationService,
    private router: Router,
    private bankingDayService: BankingDayService,
    private notificationService: NotificationService,
    private errorService: GlobalErrorHandlerService,
    private currencyService: CurrencyService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  login() {
    this.loginService.login(this.user).subscribe({
      next: (data) => {
        this.getBusinessDay();
        this.getLocalCurrency();

        if (this.authorizationService.isAdmin()) {
          this.router.navigate([this.authorizationService.getFirstAccessibleAdminRoute()]);
        } else {
         this.router.navigate([this.authorizationService.getFirstAccessibleUserRoute()]);
        }
      },
      error: (ex) => {
        if (ex?.error?.message) {
          this.errorMessage = ex.error.message;
        }
        else if (ex.status == 401) {
          this.errorMessage = this.translate.instant('message.incorrect_user_pass')
        }
        else {
          this.errorMessage = this.translate.instant('error.internalServerError')
        }
      }
    });
  }

  toggleEyeOpened(event, opened) {
    event.preventDefault();
    this.eyeOpened = opened;
  }

  getBusinessDay() {
    this.bankingDayService.getBusinessDay().subscribe({
      next: data => {
        const dateArray = data.split('-');
        localStorage.setItem('businessDay', dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0])
      },
      error: (err) => {
        this.errorMessage = this.errorService.handleError(err);
        if(this.errorMessage)
        this.notificationService.showErrorMessage( `${this.errorMessage}`);
      }
    })
  }

  getLocalCurrency() {
    const pageParam = {
      size: 20,
      page: 0
    }
    let currencies = new Array<Currency>();
    this.currencyService.getList(pageParam).subscribe({
      next: (data) => {
        currencies = data.content.filter((elem) => elem.default === true);
        localStorage.setItem('localCurrency', currencies[0].isoCode)
      },
      error: () => {
        this.notificationService.showErrorMessage(this.translate.instant('error.not_configured_currency'));
      }
    });
  }

}
